import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { FeatureFlags } from '../firebase/featureFlags';

export interface FeatureFlagState {
  featureFlags: FeatureFlags;
}

const initialState: FeatureFlagState = {
  featureFlags: {},
};

const featureFlagSlice = createSlice({
  name: 'featureFlags',
  initialState,
  reducers: {
    setFeatureFlags: (state, action: PayloadAction<FeatureFlags>) => {
      state.featureFlags = action.payload;
    },
  },
});

export const { setFeatureFlags } = featureFlagSlice.actions;
export default featureFlagSlice.reducer;
